export function isMacOS() {
  const userAgent = window.navigator.userAgent
  if (userAgent.toLowerCase().includes('mac')) {
    return true
  }
  return false
}
